"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = Table;

var _react = _interopRequireWildcard(require("react"));

var _StripesTheme = require("../../StripesTheme.js");

var _react2 = require("../..");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("@zebra-fed/icons/Navigation/index.css");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    width: fit-content;\n    display: flex;\n    visibility: hidden;\n    opacity: 0;\n    height: fit-content;\n    margin-left: auto;\n    transition: all 0.5s;\n "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;    \n    align-items: center;\n    height: 100%;\n    margin-right: auto;\n "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    flex-direction: column;\n    margin-left: 4px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    text-align: left;\n    width: ", "px;\n    height: ", "px;\n    border: ", ";\n    border-bottom: ", ";\n    font-weight: bold;\n    padding-left: ", "px;\n "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    text-align: left;\n    width: ", "px;\n    height: ", "px;\n    border: ", ";\n    border-bottom: ", ";\n    padding-left: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    height: ", "px;\n    width: ", "px;\n    background: ", ";\n\n    &:nth-child(even) {\n        background: ", ";\n    }\n    &:hover {\n        background: ", ";\n    }\n    &:hover .action-container {     \n        visibility: visible;\n        opacity: 100;\n    } \n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    border-spacing: 0;\n    width: 100%;\n    border-collapse: collapse;\n    font-family: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TableWrapper = _styledComponents["default"].table(_templateObject(), function (props) {
  return props.fontFamilyObj;
});

var Tr = _styledComponents["default"].tr(_templateObject2(), function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return props.spacingObj.width;
}, function (props) {
  return props.checked ? '#E5F1F7' : props.colorObj.background;
}, function (props) {
  return props.type === 'striped' ? props.colorObj.stripeBackground : props.colorObj.background;
}, function (props) {
  return props.checked ? '#E5F1F7' : props.colorObj.backgroundHover;
});

var Td = _styledComponents["default"].td(_templateObject3(), function (props) {
  return props.spacingObj.cellWidth;
}, function (props) {
  return props.spacingObj.cellHeight;
}, function (props) {
  return props.type === 'border' ? "1px solid ".concat(props.colorObj.border) : 'none';
}, function (props) {
  return props.type !== 'border' ? "1px solid ".concat(props.colorObj.border) : '';
}, function (props) {
  return props.spacingObj.basePadding;
});

var Th = _styledComponents["default"].th(_templateObject4(), function (props) {
  return props.spacingObj.cellWidth;
}, function (props) {
  return props.spacingObj.cellHeight;
}, function (props) {
  return props.type === 'border' ? "1px solid ".concat(props.colorObj.border) : 'none';
}, function (props) {
  return props.type !== 'border' ? "1px solid ".concat(props.colorObj.border) : 'none';
}, function (props) {
  return props.spacingObj.basePadding;
});

var SortIconsContainer = _styledComponents["default"].div(_templateObject5());

var ActionRow = _styledComponents["default"].div(_templateObject6());

var ActionContainer = _styledComponents["default"].div(_templateObject7());

function Table(_ref) {
  var defaultHeaders = _ref.defaultHeaders,
      defaultData = _ref.defaultData,
      type = _ref.type,
      pageSize = _ref.pageSize,
      pages = _ref.pages,
      checkbox = _ref.checkbox,
      rowActions = _ref.rowActions,
      onSelectedChanged = _ref.onSelectedChanged,
      onRowClicked = _ref.onRowClicked,
      onRowHovered = _ref.onRowHovered,
      style = _ref.style,
      headerStyle = _ref.headerStyle,
      showSort = _ref.showSort;

  var _useState = (0, _react.useState)(defaultData),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      numClicked = _useState4[0],
      setNumClicked = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var _useState7 = (0, _react.useState)(defaultHeaders),
      _useState8 = _slicedToArray(_useState7, 2),
      headers = _useState8[0],
      setHeaders = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = _slicedToArray(_useState9, 2),
      sortedHeaders = _useState10[0],
      setSortedHeaders = _useState10[1];

  var inherit = 'table';
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[inherit][type];
  var colors = context.getColors()[inherit][type];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      val = _useState12[0],
      forceRerender = _useState12[1];

  (0, _react.useEffect)(function () {
    onSelectedChanged(selected);
  }, [selected]);
  (0, _react.useEffect)(function () {
    setData(defaultData);

    if (!selected.empty) {
      setSelected([]);
    }
  }, [defaultData]);
  (0, _react.useEffect)(function () {
    setHeaders(defaultHeaders);
  }, [defaultHeaders]);

  function onSortChange(item, order) {
    var res = sortedHeaders.filter(function (val) {
      return val.name === item.name;
    })[0];

    if (res) {
      if (res.order !== order) {
        res.order = order;
        forceRerender(!val);

        if (item.onSortChange) {
          item.onSortChange(order);
        }
      } else {
        var temp = sortedHeaders;
        var i = temp.indexOf(res);
        temp.splice(i, 1);
        setSortedHeaders(temp);
        forceRerender(!val);
      }
    } else {
      setSortedHeaders(sortedHeaders.concat({
        name: item.name,
        order: order
      }));

      if (item.onSortChange) {
        item.onSortChange(order);
      }
    }
  }

  function Headers(selected, headers, type, checkbox) {
    function expensive(headers, type, checkbox) {
      return headers.map(function (item, index) {
        var sortInfo = sortedHeaders.filter(function (val) {
          return val.name === item.name;
        })[0];
        return /*#__PURE__*/_react["default"].createElement(Th, {
          colorObj: colors,
          spacingObj: spacing,
          type: type,
          key: index,
          style: item.style
        }, !index && checkbox && /*#__PURE__*/_react["default"].createElement(_react2.Checkbox, {
          checked: data.length === 0,
          style: item.style,
          label: item.name,
          partiallySelected: selected.length > 0 && selected.length < data.length,
          key: "headinginput".concat(index),
          type: "checkbox",
          onChange: function onChange(event) {
            return setSelected(selectAll(data, selected.length === data.length));
          }
        }) || item.name, showSort && !item.hideSort && /*#__PURE__*/_react["default"].createElement(SortIconsContainer, null, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
          category: 'navigation',
          name: 'drop-down-up',
          size: 8,
          color: sortInfo ? sortInfo.order === 'asc' ? colors.activeSortIconColor : colors.sortIconColor : colors.sortIconColor,
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick() {
            return onSortChange(item, 'asc');
          }
        }), /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
          category: 'navigation',
          name: 'drop-down-down',
          size: 8,
          color: sortInfo ? sortInfo.order === 'desc' ? colors.activeSortIconColor : colors.sortIconColor : colors.sortIconColor,
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick() {
            return onSortChange(item, 'desc');
          }
        })));
      });
    }

    return expensive(headers, type, checkbox);
  }

  function computeSelection(index, pageSize, numClicked, sel) {
    var arr = selected.slice(0);
    var clickedItem = numClicked * pageSize + index;

    if (sel) {
      arr.push(clickedItem);
    } else {
      var i = selected.indexOf(clickedItem);
      arr.splice(i, 1);
    }

    return arr;
  }

  function selectAll(data, sel) {
    var arr = [];

    if (selected.length < data.length && selected.length > 0) {
      return arr;
    }

    if (sel) {
      return arr;
    }

    for (var i = 0; i < data.length; i++) {
      arr.push(i);
    }

    return arr;
  }

  function Rows(data, type, pageSize, numClicked) {
    if (!data) return;
    var start = numClicked * pageSize;
    var end = start + pageSize;
    var condensed = [];

    for (var i = start; i < end; i++) {
      if (data[i]) {
        condensed.push(data[i]);
      } else {
        condensed.push({
          blank: true
        });
      }
    }

    return condensed.map(function (row, index) {
      if (index >= pageSize) return;

      if (row.blank) {
        return /*#__PURE__*/_react["default"].createElement(Tr, {
          key: index,
          colorObj: colors,
          spacingObj: spacing,
          type: type
        }, /*#__PURE__*/_react["default"].createElement(Td, {
          colorObj: colors,
          spacingObj: spacing,
          type: type,
          style: {
            visibility: 'hidden'
          }
        }));
      }

      var itemIndex = index + numClicked * pageSize;

      function rowClick(e) {
        onRowClicked(e, itemIndex);
      }

      function rowHover(e) {
        onRowHovered(e, itemIndex);
      }

      return /*#__PURE__*/_react["default"].createElement(Tr, {
        key: index,
        checked: selected.includes(itemIndex),
        colorObj: colors,
        spacingObj: spacing,
        type: type,
        onMouseDown: function onMouseDown(e) {
          return rowClick(e);
        },
        onMouseEnter: function onMouseEnter(e) {
          return rowHover(e);
        }
      }, Object.values(row).map(function (item, i) {
        var _React$createElement;

        var sel = selected.includes(itemIndex);
        var columnStyle = headers[i].columnStyle;
        return /*#__PURE__*/_react["default"].createElement(Td, {
          key: i,
          colorObj: colors,
          spacingObj: spacing,
          type: type,
          style: columnStyle
        }, i !== Object.values(row).length - 1 ? !i && checkbox && /*#__PURE__*/_react["default"].createElement(_react2.Checkbox, (_React$createElement = {
          key: "checkbox ".concat(i),
          checked: selected.includes(itemIndex),
          label: item
        }, _defineProperty(_React$createElement, "key", "input".concat(itemIndex)), _defineProperty(_React$createElement, "type", "checkbox"), _defineProperty(_React$createElement, "style", columnStyle), _defineProperty(_React$createElement, "onChange", function onChange() {
          return setSelected(computeSelection(index, pageSize, numClicked, !sel));
        }), _React$createElement)) || item : /*#__PURE__*/_react["default"].createElement(ActionRow, {
          style: columnStyle,
          key: "action"
        }, item, /*#__PURE__*/_react["default"].createElement(ActionContainer, {
          className: "action-container"
        }, rowActions.map(function (action, i) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: "action ".concat(i)
          }, action);
        }))));
      }));
    });
  }

  function pageItemClick(type) {
    setNumClicked(type);
  }

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(TableWrapper, {
    id: type,
    fontFamilyObj: context.getFont(),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement(Tr, {
    colorObj: colors,
    spacingObj: spacing,
    type: type,
    style: headerStyle
  }, Headers(selected, headers, type, checkbox)), Rows(data, type, pageSize, numClicked, checkbox))), pages && /*#__PURE__*/_react["default"].createElement(_react2.Pagination, {
    numClicked: numClicked,
    callback: pageItemClick,
    pageSize: pageSize,
    dataSize: data.length,
    maxSize: pageSize
  }));
}

Table.defaultProps = {
  defaultData: [],
  defaultHeaders: [],
  type: 'striped',
  pageSize: 10,
  pages: true,
  checkbox: false,
  rowActions: [],
  style: {},
  headerStyle: {},
  showSort: false,
  onSelectedChanged: function onSelectedChanged() {
    return false;
  },
  onRowClicked: function onRowClicked() {
    return false;
  },
  onRowHovered: function onRowHovered() {
    return false;
  }
};
Table.propTypes = {
  /**A data object containing an array of column objects. */
  defaultData: _propTypes["default"].array,

  /**An array of objects that defines the table headers. Accepted attributes are 'name', 'style', 'hideSort', 'onSortChange', and 'columnStyle. */
  defaultHeaders: _propTypes["default"].array,

  /**The type of table to display. Options are border, striped, default, dense, xDense. */
  type: _propTypes["default"].string,

  /**The max amount of rows to display at any one time. */
  pageSize: _propTypes["default"].number,

  /**Pagination visibility. */
  pages: _propTypes["default"].bool,

  /**Checkbox visibility. */
  checkbox: _propTypes["default"].bool,

  /**An array of elements displayed when a row is hovered over. */
  rowActions: _propTypes["default"].array,

  /**A style object applied to the entire table */
  style: _propTypes["default"].object,

  /**A style object applied to the header */
  headerStyle: _propTypes["default"].object,

  /**Shows the sorting icons on the header */
  showSort: _propTypes["default"].bool,

  /**A callback function that's fired whenever the selected values change. Receives an array of indexes of the selected rows. */
  onSelectedChanged: _propTypes["default"].func,

  /**A callback function that's fired when a row is clicked. Receives the event object and the index of the clicked row. */
  onRowClicked: _propTypes["default"].func,

  /**A callback function that's fired when a row is hovered. Receives the event object and the index of the hovered row. */
  onRowHovered: _propTypes["default"].func
};